module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalelectricians.com.au/images/review_2-b065bdefdfd82f089f65cc915d68a7d4.png";